import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useWebSocket } from 'context/WebSocketContext';
import React from 'react'
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { loginUser } from 'services/apiAuth1';

const useLoginTA = () => {
  
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    // const{connectWebSocket}=useWebSocket();

    const{isPending:isSigningIn,mutate: login}=useMutation({
        mutationFn:(data)=> loginUser(data),
        onSuccess:(data) =>{
            localStorage.setItem("loginData",JSON.stringify(data))
            queryClient.setQueryData(['mfa-session'],data)
            // localStorage.setItem("userData",JSON.stringify(data))
            // localStorage.setItem("accessToken",JSON.stringify(data.access))
            // localStorage.setItem("refreshToken",JSON.stringify(data.refresh))
            // connectWebSocket(data.access)
            // queryClient.setQueryData(["userData",data])
            // toast.success("Login Successful")
            navigate('/mfa-verify', {replace:true})
        },
        onError:(error)=>{
            console.log("Login error:", error);
            if (error?.data && typeof error.data === 'object'){
                for (const key in error.data) {
                const messages = error.data[key]
                const message = Array.isArray(messages) ? messages[0] : messages
                toast.error(message)
                }
            }else{
                toast.error("Something went wrong. Please try again.")
            }
        }
    })

    return{isSigningIn,login}
}

export default useLoginTA